import { gql } from '@apollo/client';

export const GET_ROSTER_COMMENTS = gql`
  query GetRosterComments($activityId: String!, $activityDate: Date!) {
    vm {
      rosterComments(activityId: $activityId, activityDate: $activityDate) {
        commentId
        parentId
        content
        submittedDate
        removedDate
        attachments {
          attachmentId
          fileType
          url
          name
        }
        volunteer {
          volunteerId
          profile {
            preferredName
            lastName
            avatarUrl
          }
        }
        reactions {
          reactionId
          emoji
          volunteer {
            volunteerId
          }
        }
      }
    }
  }
`;

export const GET_ROSTER_TEMPLATE_COMMENTS = gql`
  query GetRosterTemplateComments($rosterTemplateId: String!) {
    vm {
      rosterTemplateComments(rosterTemplateId: $rosterTemplateId) {
        commentId
        parentId
        content
        submittedDate
        removedDate
        attachments {
          attachmentId
          fileType
          url
          name
        }
        volunteer {
          volunteerId
          profile {
            preferredName
            lastName
            avatarUrl
          }
        }
        reactions {
          reactionId
          emoji
          volunteer {
            volunteerId
          }
        }
      }
    }
  }
`;
